import React, { useEffect } from "react";
import styled from "styled-components";
import get from "lodash/get";
import UpcomingWeekendEvent from "components/event/UpcomingWeekendEvent";
import NextEvent from "components/event/NextEvent";
import { connect } from "react-redux";
import Teamspeak from "components/dashboard/Teamspeak";
import Discord from "components/dashboard/Discord";
import ArmaUnits from "components/dashboard/ArmaUnits";
import Steam from "components/dashboard/Steam";
import Github from "components/dashboard/Github";
import { modifyDocumentTitle } from "components/utils";
import { getEventsListAction } from "store/actions";

const Dashboard = ({ getEvents, isMobile }) => {
  useEffect(() => {
    getEvents();
  }, [getEvents]);

  modifyDocumentTitle("Home");

  return (
    <Wrapper id={"wrapper"} isMobile={isMobile}>
      <EventWrapper isMobile={isMobile}>
        <NextEvent />
        <UpcomingWeekendEvent day={"friday"} />
        <UpcomingWeekendEvent day={"saturday"} />
        <UpcomingWeekendEvent day={"sunday"} />
      </EventWrapper>
      <OutboundItemsWrapper isMobile={isMobile} id={"outbound"}>
        <Discord />
        <Steam />
        <Teamspeak />
        <ArmaUnits />
        <Github />
      </OutboundItemsWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  place-content: space-evenly;
  background: #292b2f;
`;

const EventWrapper = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  flex-direction: ${(props) => (props.isMobile ? "column" : "row")};
  width: ${(props) => (props.isMobile ? "unset" : "100%")};
  justify-content: space-evenly;
  > div {
    margin-bottom: ${(props) => (props.isMobile ? "20px" : "0px")};
  }
`;

const OutboundItemsWrapper = styled.div`
  display: flex;
  flex-direction: ${(props) => (!!props.isMobile ? "column" : "row")};
  justify-content: space-evenly;
  width: 100%;
  margin-bottom: 25px;
  align-items: center;
  background: #292b2f;
  > a {
    margin-bottom: ${(props) => (!!props.isMobile ? "20px" : "0px")};
  }
`;

export const mapStateToProps = (state) => ({
  isMobile: get(state, "rootReducer.core.isMobile", false),
});

const mapDispatchToProps = {
  getEvents: getEventsListAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
